import { Loader, PageHeader } from "components";
import { GetServerSidePropsContext, NextPage } from "next";
import { NewsletterSection, SingleJob } from "sections";
import { IJobsV3Fields, IStaticNewsletterSectionFields } from "types";
import { fetchJobs, getContentfulEntries } from "../../utils/contentful-api";

const Jobs: NextPage<{
  job: IJobsV3Fields | null;
  newsletter: IStaticNewsletterSectionFields[];
}> = ({ job, newsletter }) => {
  return (
    <div>
      <PageHeader title={job?.jobPosition ?? "Jobs"} />
      {job !== null ? (
        <SingleJob jobs={job} />
      ) : (
        <Loader className="!w-24 !h-24" />
      )}
      <NewsletterSection newsletterSection={newsletter} />
    </div>
  );
};
export default Jobs;

export async function getServerSideProps({ query }: GetServerSidePropsContext) {
  if (!query.careerSlug) {
    return {};
  }
  const job = (await fetchJobs(query.careerSlug as string)) ?? null;

  const newsletter = await getContentfulEntries<IStaticNewsletterSectionFields>(
    "newsletterSection"
  );

  return {
    props: {
      job,
      newsletter,
    },
  };
}
